import { FC } from "react";
import Badge from "components-new/Badge";
import NewCheckBox from "components-new/NewCheckBox";
import { IMarker } from "toolkit/organizations/types";
import cn from "classnames";
import styles from "./SettingMarkers.module.sass";

interface MarkerProps {
	marker: IMarker;
	onChange: (markerId: number) => void;
}

const Marker: FC<MarkerProps> = ({ marker, onChange }) => {
	return (
		<label className={cn(styles.marker, styles.cursor)}>
			<Badge color={marker.colorCode!}>
				<div className={cn(styles.labelBadge, styles.cursor)}>
					<NewCheckBox checked={marker.link} type="checkbox" onChange={() => onChange(marker.id)} />
					<span className={styles.markerText}>{marker.abbreviation}</span>
				</div>
			</Badge>
		</label>
	);
};

export default Marker;
